module.exports = __webpack_public_path__ + "static/media/airbnb.751b345c.svg";